'use client';

import type { ReactNode } from 'react';

/** Soft full-width control chrome shared by the stacked setup fields. */
export const SETUP_SOFT_INPUT_CLASS =
  'w-full rounded-xl border-[color-mix(in_srgb,var(--border)_85%,transparent)] bg-[color-mix(in_srgb,var(--muted)_40%,var(--card))] shadow-none placeholder:text-[color-mix(in_srgb,var(--muted-foreground)_65%,transparent)]';

interface SetupStackedFormFieldProps {
  label: string;
  htmlFor?: string;
  required?: boolean;
  hint?: string;
  error?: string;
  children: ReactNode;
}

/** Stacked field — bold label, muted hint, full-width control below. */
export function SetupStackedFormField({
  label,
  htmlFor,
  required,
  hint,
  error,
  children,
}: SetupStackedFormFieldProps) {
  const errorId = error && htmlFor ? `${htmlFor}-error` : undefined;

  return (
    <div className="flex flex-col gap-2.5">
      <div>
        <label htmlFor={htmlFor} className="text-foreground text-[0.9375rem] font-semibold leading-tight">
          {label}
          {required ? (
            <span className="text-destructive ml-1" aria-hidden>
              *
            </span>
          ) : null}
        </label>
        {hint ? (
          <p className="text-muted-foreground m-0 mt-1 text-[0.8125rem] leading-[1.5]">{hint}</p>
        ) : null}
      </div>

      {children}

      {error ? (
        <p id={errorId} className="text-destructive m-0 text-xs" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
